import axios from "axios"
import { AppServices, HttpHeaders } from "./AppServices";

const CommonServices = {  
  GetDashboadDetail: ({ per_page = 10, page = 1, search = '', sort_by = '', sort_order = '' }) => {
    return axios.get(AppServices.GET_DASHBOARD(), {
      headers: HttpHeaders().headers,
      params: {
        per_page,
        page,
        search,
        sort_by,
        sort_order
      }
    });
  },
  VerifyConfirmDelete: (data) => {
    return axios.post(AppServices.VERIFY_CONFIRM_DELETE(), data, HttpHeaders())
  },
  GetShortcutURL: (data) => {
    return axios.post(AppServices.GET_SHORTCUT_URL(), data, HttpHeaders())
  },
  VerifyFileToken: (token) => {
    return axios.get(AppServices.VERIFY_FILE_TOKEN(token), HttpHeaders())
  },
}
export default CommonServices;
